const basePillStyles = {
  borderRadius: '10px',
  border: '1px solid',
  borderColor: 'divider',
  padding: '0 8px',
};

export const dependsOnRowStyles = {
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '4px',
  paddingLeft: '45px',
  paddingTop: '4px',
};

export const dependsOnPillStyles = {
  ...basePillStyles,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'action.hover',
  },
  '&:focus-visible': {
    outline: '2px solid',
    outlineColor: 'primary.main',
    outlineOffset: '2px',
  },
};

export const dependsOnPillReadOnlyStyles = {
  ...basePillStyles,
  cursor: 'default',
};
